/**
 * AuthPresenter
 * --
 */
import React from 'react';

const AuthPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <div>
      <p></p>
    </div>
  );
};

export default AuthPresenter;
